<template>
  <div>
    <component v-bind:is="currentViewComponent" class="view"></component>
  </div>
</template>

<script>
import Login from 'Components/Partials/Login'
// import Register from 'Components/Partials/Register'
// import PasswordForgot from 'Components/Partials/PasswordForgot'

export default {
  name: 'Auth',

  components: {
    'view-login': Login,
    // 'view-register': Register,
  },

  data() {
    return {
      currentView: 'login',
      views: [
        {
          label: 'Login',
          key: 'login',
        },
        // {
        //   label: 'Registrer',
        //   key: 'register',
        // },
      ],
    }
  },

  created() {
    // Handle "deep linking"
    let view = window.location.hash.substr(2)
    if (view) {
      this.currentView = view
    }
  },

  mounted() {
    window.addEventListener('hashchange', (data) => {
      this.currentView = window.location.hash.substr(2)
    })
  },

  computed: {
    currentViewComponent: function () {
      return 'view-' + this.currentView
    },
  },
}
</script>
